(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kupon-catalog"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kupon-catalog]').forEach(root=>{
 const cards=[...root.querySelectorAll('.kh-catalog-product')];
 function filter(value,term=''){
  let count=0;
  cards.forEach(card=>{const match=(value==='all'||card.dataset.type===value||card.dataset.group.toLowerCase()===value.toLowerCase()||(value==='Winter Living'&&['Softwin','Luxwin'].includes(card.dataset.group)))&&(!term||card.dataset.title.includes(term.toLowerCase()));card.hidden=!match;if(match)count++;});
  root.querySelectorAll('[data-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===value)));
  root.querySelector('.kh-catalog-count').textContent=count+' '+root.querySelector('.kh-catalog-count').textContent.split(' ').slice(1).join(' ');
  root.querySelector('.kh-no-results').hidden=count>0;
 }
 root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>filter(button.dataset.filter)));
 document.querySelectorAll('a[href*="#collection-"]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();const value=decodeURIComponent(link.hash.replace('#collection-',''));filter(value);link.closest('details')?.removeAttribute('open');root.scrollIntoView({behavior:'smooth'});}));
 document.querySelectorAll('.kh-search').forEach(form=>form.addEventListener('submit',event=>{event.preventDefault();filter('all',form.querySelector('[name="q"]').value.trim());root.scrollIntoView({behavior:'smooth'});}));
 root.querySelectorAll('[data-open-model]').forEach(button=>button.addEventListener('click',event=>{event.preventDefault();root.querySelector('#model-'+button.dataset.openModel).showModal();}));
 root.querySelectorAll('dialog').forEach(dialog=>{dialog.querySelector('[data-close-model]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});});
 const query=new URLSearchParams(location.search).get('catalog-search');if(query)filter('all',query);
 if(location.hash.startsWith('#collection-'))filter(decodeURIComponent(location.hash.replace('#collection-','')));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kupon-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kh-search').forEach(form=>{form.addEventListener('submit',event=>{if(document.querySelector('[data-kupon-catalog]'))return;event.preventDefault();location.href='/?catalog-search='+encodeURIComponent(form.querySelector('[name="q"]').value.trim())+'#kupon-catalog';});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
